// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__9ALl+","modal":"Modal_modal__TFDsV","slide-down":"Modal_slide-down__+qKFu"};